/* Purefix Pro – thema-JavaScript (geen build-stap nodig) */
(function () {
  'use strict';
  var PF = window.PF || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Geld ---------- */
  function formatMoney(cents) {
    var fmt = PF.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = (Number(cents) || 0) / 100;
    function sep(num, dec, thou, decSep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? parts[0] + decSep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return sep(n, 2, ',', '.');
        case 'amount_no_decimals': return sep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(n, 2, "'", '.');
        default: return sep(n, 2, '.', ',');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- Winkelmand (AJAX) ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
  }
  function openDrawer() { document.body.classList.add('cart-open'); var d = document.querySelector('.drawer'); if (d) d.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); var d = document.querySelector('.drawer'); if (d) d.setAttribute('aria-hidden', 'true'); }

  function renderDrawer(cart) {
    setCount(cart.item_count);
    var body = document.getElementById('cart-body'), total = document.getElementById('cart-total');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><p>Je winkelmand is nog leeg.</p><a class="btn btn-teal" href="' + (PF.shopUrl || root + 'collections/all') + '" data-cart-close>Naar de webshop</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      return '<div class="cart-item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
        '<div><b>' + esc(i.product_title) + '</b><small>' + formatMoney(i.final_price) + ' per stuk</small>' +
        '<div class="cart-item__qty"><button type="button" data-pf-line="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '" aria-label="Minder">−</button><span>' + i.quantity + '</span><button type="button" data-pf-line="' + esc(i.key) + '" data-q="' + (i.quantity + 1) + '" aria-label="Meer">+</button></div></div>' +
        '<div><div class="cart-item__price">' + formatMoney(i.final_line_price) + '</div><button class="cart-item__remove" type="button" data-pf-line="' + esc(i.key) + '" data-q="0">Verwijderen</button></div></div>';
    }).join('');
  }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart() { return fetchCart().then(function (c) { renderDrawer(c); updateBuybar(c); return c; }); }

  function addItems(items, opts) {
    opts = opts || {};
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt'); return data; });
    }).then(function () {
      if (document.body.getAttribute('data-template') === 'cart') { location.reload(); return; }
      return refreshCart().then(function () { if (!opts.silent) openDrawer(); toast(opts.message || 'Toegevoegd aan je winkelmand'); });
    }).catch(function (e) { toast(e.message); });
  }
  function changeLine(key, qty, sections) {
    var payload = { id: key, quantity: Math.max(0, qty) };
    if (sections) { payload.sections = sections; payload.sections_url = location.pathname; }
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Klikken ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-pf-add]'))) {
      e.preventDefault();
      var qty = 1, from = t.getAttribute('data-qty-from');
      if (from) { var inp = document.querySelector(from); qty = Math.max(1, parseInt(inp && inp.value, 10) || 1); }
      addItems([{ id: Number(t.getAttribute('data-pf-add')), quantity: qty }], { message: (t.getAttribute('data-pf-name') || 'Product') + ' toegevoegd', silent: t.hasAttribute('data-silent') });
      return;
    }
    if ((t = e.target.closest('[data-pf-add-multi]'))) {
      e.preventDefault();
      var ids = t.getAttribute('data-pf-add-multi').split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      addItems(ids, { message: t.getAttribute('data-pf-name') || 'Set toegevoegd' });
      return;
    }
    if ((t = e.target.closest('[data-pf-line]'))) {
      e.preventDefault();
      changeLine(t.getAttribute('data-pf-line'), parseInt(t.getAttribute('data-q'), 10)).then(function () { refreshCart(); });
      return;
    }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    if ((t = e.target.closest('[data-pf-tab]'))) {
      var wrap = t.closest('[data-pf-tabs]'); var name = t.getAttribute('data-pf-tab');
      wrap.querySelectorAll('[data-pf-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
      wrap.querySelectorAll('[data-pf-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-pf-panel') !== name; });
      return;
    }
    if ((t = e.target.closest('[data-pf-thumb]'))) {
      var main = document.getElementById('pf-gallery-main');
      if (main) { main.src = t.getAttribute('data-pf-thumb'); main.removeAttribute('srcset'); }
      document.querySelectorAll('[data-pf-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
      return;
    }
    if ((t = e.target.closest('[data-pf-qty]'))) {
      var input = document.querySelector('[data-pf-qty-input]');
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.getAttribute('data-pf-qty'), 10));
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Productformulier ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-pf-product-form]');
    if (!f || e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value, q = parseInt((f.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    addItems([{ id: Number(id), quantity: q }], { message: (f.getAttribute('data-pf-name') || 'Product') + ' toegevoegd' });
  });

  /* ---------- Menu ---------- */
  var burger = document.getElementById('burger'), menu = document.getElementById('mobileMenu');
  if (burger && menu) {
    burger.addEventListener('click', function () { var o = menu.classList.toggle('open'); burger.setAttribute('aria-expanded', o); burger.setAttribute('aria-label', o ? 'Menu sluiten' : 'Menu openen'); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }); });
  }

  /* ---------- Sticky bestelbalk (mobiel) ---------- */
  var bar = document.getElementById('buybar');
  function updateBuybar(cart) {
    if (!bar) return;
    var mode = bar.getAttribute('data-mode');
    if (mode === 'cart' && cart) {
      var tt = bar.querySelector('[data-bar-total]'); if (tt) tt.textContent = formatMoney(cart.total_price);
      bar.classList.toggle('show', cart.item_count > 0);
    }
  }
  function toggleBar() {
    if (!bar) return;
    var mode = bar.getAttribute('data-mode');
    if (mode === 'product') {
      var f = document.querySelector('[data-pf-product-form]');
      bar.classList.toggle('show', !!f && f.getBoundingClientRect().bottom < 0);
    } else if (mode === 'home') {
      var hero = document.querySelector('.hero');
      bar.classList.toggle('show', !!hero && window.scrollY > hero.offsetHeight - 80);
    } else if (mode === 'cart') {
      bar.classList.toggle('show', Number(bar.getAttribute('data-count') || 0) > 0);
    } else { bar.classList.remove('show'); }
  }
  window.addEventListener('scroll', toggleBar, { passive: true });
  toggleBar();

  /* ---------- Winkelmandpagina ---------- */
  function cartSection() { return document.querySelector('[data-pf-cart-section]'); }
  function rerenderCart(html) {
    var sec = cartSection(); if (!sec) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-pf-cart-section]');
    if (fresh) sec.innerHTML = fresh.innerHTML;
    fetchCart().then(function (c) { setCount(c.item_count); updateBuybar(c); if (bar) bar.setAttribute('data-count', c.item_count); });
  }
  document.addEventListener('click', function (e) {
    var sec = cartSection(); if (!sec) return;
    var t = e.target.closest('[data-cart-qty]');
    if (t) {
      e.preventDefault(); sec.classList.add('cart-loading');
      var id = sec.getAttribute('data-section-id');
      changeLine(t.getAttribute('data-key'), parseInt(t.getAttribute('data-cart-qty'), 10), [id]).then(function (r) {
        sec.classList.remove('cart-loading'); if (r.sections && r.sections[id]) rerenderCart(r.sections[id]); else location.reload();
      });
      return;
    }
    if (e.target.closest('[data-cart-clear]')) {
      e.preventDefault();
      if (!confirm('Weet je zeker dat je de winkelmand wilt legen?')) return;
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function () { location.reload(); });
      return;
    }
    if ((t = e.target.closest('[data-code-apply]'))) {
      e.preventDefault();
      var code = (document.getElementById('cart-code').value || '').trim().toUpperCase();
      sessionStorage && sessionStorage.setItem('pf_code', code);
      var msg = document.getElementById('code-msg'); if (msg) msg.textContent = code ? 'Code ' + code + ' wordt toegepast bij afrekenen.' : '';
      return;
    }
    if ((t = e.target.closest('[data-pf-checkout]'))) {
      var c = '';
      try { c = (document.getElementById('cart-code') || {}).value || sessionStorage.getItem('pf_code') || ''; } catch (x) {}
      c = c.trim();
      var note = document.getElementById('cart-note');
      var go = function () { window.location.href = c ? root + 'discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(root + 'checkout') : root + 'checkout'; };
      e.preventDefault();
      if (note) {
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).then(go, go);
      } else { go(); }
    }
  });
  document.addEventListener('change', function (e) {
    var sec = cartSection(); if (!sec) return;
    var inp = e.target.closest('[data-cart-input]');
    if (inp) {
      sec.classList.add('cart-loading');
      var id = sec.getAttribute('data-section-id');
      changeLine(inp.getAttribute('data-key'), parseInt(inp.value, 10) || 0, [id]).then(function (r) { sec.classList.remove('cart-loading'); if (r.sections && r.sections[id]) rerenderCart(r.sections[id]); else location.reload(); });
    }
    if (e.target.id === 'cart-note') {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });

  /* ---------- Start ---------- */
  if (document.querySelector('.drawer')) refreshCart();
})();
